<template>
  <section class="home__section home-banner">
    <div id="homeBanner" class="swiper-container">
      <div class="swiper-wrapper">
        <div
          v-for="item in homeBanner"
          :key="item.homeLinkId"
          class="swiper-slide"
        >
          <a
            class="home-banner__item"
            @click="clickBanner(item.homeLinkUrl)"
          >
            <div :style="{ 'background-image': `url(${ item.homeLinkImgPath })` }" />
            <div :style="{ 'background-image': `url(${ item.homeLinkImgMobilePath })` }" />
          </a>
        </div>
      </div>

      <div class="swiper-pagination" />
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </section>
</template>

<script>
import GetHomeBanner from '@/api/BannerApi';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay]);

export default {
  data() {
    return {
      homeBanner: [],
    };
  },
  async mounted() {
    await this.GetList();

    // eslint-disable-next-line no-new
    new Swiper('#homeBanner', {
      loop: true,
      slidesPerView: 1,

      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  },
  methods: {
    GetList() {
      return new Promise((resolve) => {
        GetHomeBanner()
          .then((response) => {
            if (response.data.statusCode === 0) {
              this.homeBanner = response.data.data;
            }

            resolve();
          });
      });
    },

    clickBanner(url) {
      if (url !== '') {
        window.open(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
